import { closeComposeForm } from 'owa-calendar-compose-form-actions';
import { showQuickCompose } from 'owa-calendar-compose-form-store';
import { focusNewEventButton } from 'owa-calendar-module-commanding';
import { orchestrator } from 'satcheljs';
import {
    QUICK_COMPOSE_ENTRY_SOURCE_SURFACE,
    QuickComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

let quickComposeEntryPoint: QuickComposeEntrySourceType;

export function subscribeCloseComposeFormOrchestrator() {
    orchestrator(showQuickCompose, actionMessage => {
        quickComposeEntryPoint = actionMessage.entrySource;
    });
}

orchestrator(closeComposeForm, actionMessage => {
    if (quickComposeEntryPoint == QUICK_COMPOSE_ENTRY_SOURCE_SURFACE) {
        focusNewEventButton();
    }
});
